import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'

export const form: {
    input?: InputBuildProps
    select?: SelectBuildProps
    layout?: LayoutProps
}[] = [
    {
        input: {
            id: 'titulo',
            label: 'Título',
            placeholder: 'Buscar pelo Título'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 12 }
        }
    },
    {
        select: {
            id: 'status',
            label: 'Status',
            optionsType: 'statusNotifications'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    },
    {
        input: {
            id: 'dataInicial',
            label: 'Data Inicial',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    },
    {
        input: {
            id: 'dataFinal',
            label: 'Data Final',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 4 }
        }
    }
]
